export default "__VITE_ASSET__DsBF8VUc__"